export default "__VITE_PUBLIC_ASSET__0fbd5433__"